import {ChangeDetectionStrategy, Component, computed, effect, inject, input} from '@angular/core';
import {HarbourDuesDeclaration, HarbourDuesRotterdamResponse, HarbourDuesVisit, Visit} from 'typescript-models/common';
import {AlertSeverity} from 'src/app/common/alert/alert.component';
import {HarbourDuesCargoService} from "../../../services/harbour-dues-cargo.service";
import {FormGroupDirective} from '@angular/forms';
import {toSignal} from '@angular/core/rxjs-interop';


@Component({
  selector: 'app-berth-details-rotterdam',
  templateUrl: './berth-details-rotterdam.component.html',
  styleUrl: './berth-details-rotterdam.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class BerthDetailsRotterdamComponent {
  protected readonly AlertSeverity = AlertSeverity;

  readonly visit = input.required<Visit>();
  readonly selectedDeclaration = input.required<HarbourDuesDeclaration>();
  readonly harbourDuesDetails = input.required<HarbourDuesRotterdamResponse>();
  readonly vesselDeadWeightKg = input<number>();
  readonly showValidationErrors = input<boolean>(false);

  private readonly cargoService = inject(HarbourDuesCargoService);
  private readonly form = inject(FormGroupDirective);

  private readonly harbourDuesVisit = toSignal<HarbourDuesVisit>(
    this.form.control.valueChanges,
    { initialValue: this.form.control.value }
  );

  protected readonly isCargoDeltaExceedingDeadWeight = computed(() => {
    const visit = this.harbourDuesVisit();
    if (!visit) {
      return false;
    }
    const {
      isTotalExceeding,
      isAnyBerthVisitExceeding
    } = this.cargoService.isVisitGoodsDeltaExceedingWeight(
      visit, this.vesselDeadWeightKg()
    );
    return isTotalExceeding && !isAnyBerthVisitExceeding;
  }, {equal: () => false});

  protected readonly vesselDeadWeightTons = computed(
    () => (this.vesselDeadWeightKg() || 0) / 1000
  );

  constructor() {
    effect(() => {
      this.form.control.setErrors(
        this.isCargoDeltaExceedingDeadWeight() ?
          { deadweight: true } : null
      );
    });
  }
}
